var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "relative" },
    [
      _c("div", { staticClass: "flex h-13" }, [
        !_vm.entry.is_baseline && _vm.rearrangeState
          ? _c(
              "div",
              {
                staticClass:
                  "absolute z-20 flex items-center justify-center h-6 border rounded-full cursor-move handle -top-3 w-30 border-light-purple bg-pure-white",
                style: { left: "50%", transform: "translateX(-50%)" }
              },
              [
                _c("BlIcon", {
                  staticClass: "flex-shrink-0 w-4",
                  style: { transform: "rotate(90deg)" },
                  attrs: { icon: "drag" }
                })
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c("div", {
          staticClass: "sticky left-0 z-10 flex pl-6 bg-pure-white"
        }),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "flex items-center flex-grow gap-6 w-200",
            class: { "border-t border-slate-400": !_vm.entry.is_baseline }
          },
          [
            _vm.entry.is_baseline
              ? _c("div", {
                  staticClass: "w-full bg-grey-200 h-0.5 rounded-full"
                })
              : _c(
                  "div",
                  { staticClass: "flex items-center justify-between w-full" },
                  _vm._l(8, function(n) {
                    return _c("div", {
                      key: n,
                      staticClass: "bg-grey-200 h-0.5 w-8 rounded-full"
                    })
                  }),
                  0
                ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "flex items-center flex-shrink-0 gap-2" },
              [
                !_vm.isPrompting
                  ? _c("div", {
                      staticClass: "flex-shrink-0 w-5 h-5 rounded-full",
                      style: {
                        backgroundColor:
                          _vm.phaseLineColors[_vm.entry.line_color]
                      }
                    })
                  : _vm._e(),
                _vm._v(" "),
                _c("BlTextSubtitle2", {
                  staticClass: "text-grey-400",
                  attrs: { text: _vm.entry.line_label }
                }),
                _vm._v(" "),
                _vm.entry.is_baseline && _vm.rearrangeState
                  ? _c("BlIcon", {
                      staticClass: "flex-shrink-0 w-5 h-5",
                      attrs: {
                        icon: "info",
                        tooltip: "This phase cannot be moved."
                      }
                    })
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.entry.is_baseline
              ? _c("div", {
                  staticClass: "w-full bg-grey-200 h-0.5 rounded-full"
                })
              : _c(
                  "div",
                  { staticClass: "flex items-center justify-between w-full" },
                  _vm._l(8, function(n) {
                    return _c("div", {
                      key: n,
                      staticClass: "bg-grey-200 h-0.5 w-8 rounded-full"
                    })
                  }),
                  0
                )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "sticky right-0 z-10 flex pr-6 bg-pure-white" },
          [
            _c(
              "div",
              {
                staticClass:
                  "relative flex items-center flex-shrink-0 w-12 px-2 transition-all duration-300 bg-pure-white",
                class: { "border-t border-slate-400": !_vm.entry.is_baseline }
              },
              [
                _c(
                  "div",
                  { staticClass: "relative", attrs: { id: "entry-menu" } },
                  [
                    _c("BlInputButton", {
                      staticClass:
                        "flex items-center justify-center w-6 h-6 hover:bg-hover-state",
                      attrs: { icon: "dots-vertical", type: "plain" },
                      on: {
                        clicked: function($event) {
                          _vm.menuOpened = !_vm.menuOpened
                        }
                      }
                    }),
                    _vm._v(" "),
                    _vm.menuOpened
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "absolute top-0 z-50 flex flex-col p-1 space-y-1 border rounded right-8 bg-pure-white border-grey-200"
                          },
                          [
                            _vm.entry.line_description
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "px-4 py-2 text-left rounded outline-none hover:bg-hover-state w-44",
                                    on: {
                                      click: function($event) {
                                        $event.preventDefault()
                                        _vm.descriptionOpened = true
                                      }
                                    }
                                  },
                                  [
                                    _c("BlTextBody2", {
                                      staticClass: "text-slate-1000",
                                      attrs: { text: "View description" }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass:
                                  "px-4 py-2 text-left rounded outline-none hover:bg-hover-state w-44",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    _vm.editOpened = true
                                  }
                                }
                              },
                              [
                                _c("BlTextBody2", {
                                  staticClass: "text-slate-1000",
                                  attrs: { text: "Edit phase" }
                                })
                              ],
                              1
                            )
                          ]
                        )
                      : _vm._e()
                  ],
                  1
                )
              ]
            )
          ]
        )
      ]),
      _vm._v(" "),
      _vm.descriptionOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: { label: "Close", cancelLabel: "Edit" },
              on: {
                "backdrop-close": function($event) {
                  _vm.descriptionOpened = false
                  _vm.editOpened = true
                },
                "backdrop-action": function($event) {
                  _vm.descriptionOpened = false
                }
              }
            },
            [
              _c(
                "div",
                {
                  staticClass: "relative px-8 overflow-y-auto",
                  style: { maxHeight: "calc(100vh - 14rem)" }
                },
                [
                  _c(
                    "div",
                    { staticClass: "flex flex-col" },
                    [
                      _c(
                        "div",
                        {
                          staticClass:
                            "sticky top-0 z-10 flex items-center gap-3 pb-4 bg-pure-white"
                        },
                        [
                          !_vm.isPrompting
                            ? _c("div", {
                                staticClass:
                                  "flex-shrink-0 w-6 h-6 rounded-full",
                                style: {
                                  backgroundColor:
                                    _vm.phaseLineColors[_vm.entry.line_color]
                                }
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("BlTextTitle4", {
                            attrs: { text: _vm.entry.line_label }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("BlTextBody2", {
                        staticClass: "flex-wrap break-words w-136",
                        attrs: { text: _vm.entry.line_description }
                      })
                    ],
                    1
                  )
                ]
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.editOpened && !_vm.deleteOpened
        ? _c(
            "BlBackdrop",
            {
              attrs: {
                title: "Edit phase line",
                label: "Update",
                disabled: !_vm.labelInput.model || _vm.submitLoading
              },
              on: {
                "backdrop-close": function($event) {
                  _vm.editOpened = false
                },
                "backdrop-action": _vm.onSave
              }
            },
            [
              _c(
                "div",
                { staticClass: "relative flex flex-col gap-4 px-8" },
                [
                  _c(
                    "div",
                    { staticClass: "flex gap-4" },
                    [
                      _c("BlInputText", {
                        attrs: { input: _vm.labelInput },
                        on: { changed: _vm.inputHandler }
                      }),
                      _vm._v(" "),
                      !_vm.isPrompting
                        ? _c("div", { staticClass: "relative" }, [
                            _c(
                              "label",
                              { staticClass: "relative mb-1" },
                              [_c("BlTextBody3", { attrs: { text: "Color" } })],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "relative flex items-center justify-between w-24 h-10 px-4 border rounded cursor-pointer",
                                class: _vm.colorOpened
                                  ? "border-light-purple "
                                  : "border-grey-200 ",
                                attrs: { "data-id": "phase-line-color" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    _vm.colorOpened = !_vm.colorOpened
                                  }
                                }
                              },
                              [
                                _c("div", {
                                  staticClass:
                                    "flex-shrink-0 w-6 h-6 rounded-full",
                                  style: {
                                    backgroundColor:
                                      _vm.phaseLineColors[_vm.colorInput]
                                  }
                                }),
                                _vm._v(" "),
                                _c("BlIcon", {
                                  staticClass:
                                    "absolute w-5 h-5 transition-all duration-300 right-4",
                                  style: _vm.colorOpened
                                    ? "rotate: 180deg"
                                    : "",
                                  attrs: {
                                    "data-id": "phase-line-color",
                                    icon: "chevron-down"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.colorOpened
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "absolute right-0 z-10 py-4 pl-4 mt-2 border rounded shadow-md w-38 max-h-48 bg-pure-white border-grey-200",
                                    attrs: { "data-id": "phase-line-color" }
                                  },
                                  [
                                    _c(
                                      "div",
                                      {
                                        attrs: { "data-id": "phase-line-color" }
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticClass: "flex flex-wrap gap-2",
                                            attrs: {
                                              "data-id": "phase-line-color"
                                            }
                                          },
                                          _vm._l(
                                            Object.keys(_vm.phaseLineColors),
                                            function(color) {
                                              return _c("button", {
                                                key: color,
                                                staticClass:
                                                  "flex-shrink-0 w-6 h-6 border-2 rounded outline-none",
                                                class:
                                                  color === _vm.colorInput
                                                    ? "border-light-purple"
                                                    : "border-transparent",
                                                style: {
                                                  backgroundColor:
                                                    _vm.phaseLineColors[color]
                                                },
                                                attrs: { title: color },
                                                on: {
                                                  click: function($event) {
                                                    $event.preventDefault()
                                                    _vm.colorInput = color
                                                  }
                                                }
                                              })
                                            }
                                          ),
                                          0
                                        )
                                      ]
                                    )
                                  ]
                                )
                              : _vm._e()
                          ])
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("BlInputText", {
                    attrs: { input: _vm.descriptionInput },
                    on: { changed: _vm.inputHandler }
                  }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "absolute z-10 left-8 -bottom-14" },
                    [
                      _c(
                        "BlTooltip",
                        {
                          attrs: {
                            tooltip: _vm.entry.is_baseline
                              ? "Baseline can't be deleted"
                              : ""
                          }
                        },
                        [
                          _c("BlInputButton", {
                            attrs: {
                              type: "plain-error",
                              icon: "trash",
                              label: "Delete phase line",
                              disabled: _vm.entry.is_baseline
                            },
                            on: {
                              clicked: function($event) {
                                _vm.deleteOpened = true
                              }
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _vm.deleteOpened
        ? _c("BlBackdrop", {
            attrs: {
              title: "Delete the phase line",
              label: "Delete",
              description:
                "Are you sure you want to delete this phase line? Deleting it will only remove the phase line itself and won't affect your data.",
              type: "error",
              empty: "",
              disabled: _vm.submitLoading
            },
            on: {
              "backdrop-close": function($event) {
                _vm.deleteOpened = false
              },
              "backdrop-action": _vm.onRemove
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2bfcd574", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2bfcd574","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/clients/target/EntryPhaseLine.vue
// module id = null
// module chunks = 